export default "__VITE_ASSET__DZpmyokF__"